module.exports = __webpack_public_path__ + "img/image-visit-us-01-academy-template-p-1080.fec5b611.jpeg";